<template>    
    <v-expansion-panel-header class="pa-2" :color="color">
        <div class="pa-2 d-flex">
            <div class="d-flex align-center">
                <v-icon color="black" v-text="icon" />
            </div>
            <div class="ml-2 flex-grow-1">
                <div class="font-weight-bold" v-text="title" />
                <div class="text--secondary" v-text="subtitle" />
            </div>
        </div>
    </v-expansion-panel-header>
</template>

<script>
export default {
    name: 'zoezi-expansionpanel-header',

    props: {
        icon: {
            title: 'Icon',
            type: String,
            fulltype: 'icon'
        },
        title: {
            title: 'Title',
            type: String
        },
        subtitle: {
            title: 'Subtitle',
            type: String
        },
        color: {
            title: 'Color',
            type: String,
            default: '#f0f0f0'
        }
    }
}
</script>